import { createContext } from 'react';

const GlobalLoaderContext = createContext<{
  show?: () => void;
  hide?: () => void;
  visible?: boolean;
}>({});

export default GlobalLoaderContext;
